var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9993 24.5013C19.7983 24.5013 24.4993 19.8003 24.4993 14.0013C24.4993 8.20231 19.7983 3.5013 13.9993 3.5013C8.20036 3.5013 3.49935 8.20231 3.49935 14.0013C3.49935 19.8003 8.20036 24.5013 13.9993 24.5013ZM13.9993 26.8346C21.087 26.8346 26.8327 21.089 26.8327 14.0013C26.8327 6.91365 21.087 1.16797 13.9993 1.16797C6.91169 1.16797 1.16602 6.91365 1.16602 14.0013C1.16602 21.089 6.91169 26.8346 13.9993 26.8346Z",
    fill: "#E8192C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8326 12.8346V6.80859H15.1659V15.1639L8.36197 15.1757L8.35791 12.8424L12.8326 12.8346Z",
    fill: "#E8192C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeRed);
export default __webpack_public_path__ + "static/media/time-red.1ff1a22eda66c8e4ecc3d3069fdbcae8.svg";
export { ForwardRef as ReactComponent };